<!-- 
An up / down indicator for use on the sandbox screen.

Shows changes in levies causes by changes to sandbox settings.
-->
<template>
  <span>
    <template v-if="hasData">
      <template v-if="difference">
        <template v-if="isPercentage">
          <p v-if="up" :class="css">
            <v-icon :small="small" color="red">arrow_upward</v-icon>
            Up from {{ original | percentage }}
          </p>
          <p v-else :class="css">
            <v-icon :small="small" color="green">arrow_downward</v-icon>
            Down from {{ original | percentage }}
          </p>
          <p v-if="suffix" :class="css" class="mb-3">{{ suffix }}</p>
        </template>
        <template v-if="!isPercentage">
          <p v-if="up" :class="css">
            <v-icon :small="small" color="red">arrow_upward</v-icon>
            Up {{ difference | currency }}
          </p>
          <p v-else :class="css">
            <v-icon :small="small" color="green">arrow_downward</v-icon>
            Down {{ -difference | currency }}
          </p>
          <p v-if="suffix" :class="css" class="mb-3">{{ suffix }}</p>
        </template>
      </template>
      <template v-if="!difference && showWhenNoDifference">
        <p :class="css">
          <v-icon :small="small" color="orange">fiber_manual_record</v-icon>
          No change
        </p>
        <p v-if="suffix" :class="css" class="mb-3">{{ suffix }}</p>
      </template>
    </template>
    <div v-else class="mb-3">&nbsp;</div>
  </span>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  props: {
    original: {
      validator: prop => typeof prop === "number" || prop === null || prop === undefined,
      required: true
    },
    current: {
      validator: prop => typeof prop === "number" || prop === null || prop === undefined,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    isPercentage: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    showWhenNoDifference: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String,
      default: null
    }
  },
  computed: {
    up() {
      return this.difference > 0;
    },
    difference() {
      return this.hasData ? this.current - this.original : 0;
    },
    hasData() {
      return this.original != null && this.current != null;
    },
    css() {
      return {
        caption: this.small,
        subheading: this.large,
        "body-1": !this.small && !this.large,
        "text-xs-center": this.center,
        "mb-0": this.suffix,
        "mb-3": !this.suffix
      };
    }
  }
};
</script>
